import React from 'react'

const SpeedTestIcon = ({ size = 24, className, ...props }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path 
        d="M2 13.9999C2 8.47709 6.47715 3.99994 12 3.99994C17.5228 3.99994 22 8.47709 22 13.9999" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M12 14.0001L15.5 10.0001" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M12 14.0001C12.5523 14.0001 13 14.4478 13 15.0001C13 15.5523 12.5523 16.0001 12 16.0001C11.4477 16.0001 11 15.5523 11 15.0001C11 14.4478 11.4477 14.0001 12 14.0001Z" 
        fill="currentColor"
      />
      <path 
        d="M4.5 16.5001H2" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M22 16.5001H19.5" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M6 10.5001L4.5 9.00006" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M19.5 9.00006L18 10.5001" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SpeedTestIcon
